import type { LanguageSupport } from '@codemirror/language';
import type { LintSource } from '@codemirror/lint';

export type CodeLanguage = 'json' | 'javascript' | 'bash' | 'toml' | 'yaml';

export interface LanguageModule {
	lang: LanguageSupport;
	lintSource?: LintSource;
}

type LanguageLoader = () => Promise<LanguageModule>;

export const languageLoaders: Record<CodeLanguage, LanguageLoader> = {
	json: () => import('@codemirror/lang-json').then(({ json, jsonParseLinter }) => ({
		lang: json(),
		lintSource: jsonParseLinter(),
	})),
	javascript: () => import('@codemirror/lang-javascript').then(({ javascript }) => ({
		lang: javascript({ typescript: true }),
	})),
	bash: () => Promise.all([
		import('@codemirror/language'),
		import('@codemirror/legacy-modes/mode/shell'),
	]).then(([{ LanguageSupport, StreamLanguage }, { shell }]) => ({
		lang: new LanguageSupport(StreamLanguage.define(shell)),
	})),
	toml: () => Promise.all([
		import('@codemirror/language'),
		import('@codemirror/legacy-modes/mode/toml'),
	]).then(([{ LanguageSupport, StreamLanguage }, { toml }]) => ({
		lang: new LanguageSupport(StreamLanguage.define(toml)),
	})),
	yaml: () => import('@codemirror/lang-yaml').then(({ yaml }) => ({
		lang: yaml(),
	})),
};
